import { RootState } from "../../../../../redux/store";

export const isDropDownItemsLoading = (state:RootState) => state.proceduresConditions.dropDownLoading;
export const getDropDownItems = (state:RootState) => state.proceduresConditions.dropDownItems;